import {styled} from '@mui/material/styles';

export const ShipToLabelWrapper = styled('div')({
  whiteSpace: 'nowrap'
});
